import KrBacktestPanel from '../components/backtest/KrBacktestPanel';
import './Backtest.css';
import './KrBacktest.css';

export default function KrBacktest() {
  return (
    <div className="backtest-page-container">
      <KrBacktestPanel showHeader />
    </div>
  );
}
